import gql from "graphql-tag";

import { pageInfoFragment } from "./pageInfo";

export const appConfigurationFragment = gql`
  fragment AppConfigurationFragment on AppConfig {
    id
    name
    version
    file
    url
    createdBy {
      email
      firstName
      lastName
    }
    updatedBy {
      email
      firstName
      lastName
    }
    createdAt
    updatedAt
  }
`;

export const appConfigurationDetailsFragment = gql`
  ${appConfigurationFragment}
  ${pageInfoFragment}
  fragment AppConfigurationDetailsFragment on AppConfig {
    id
    name
    version
    file
    url
    createdBy {
      email
      firstName
      lastName
    }
    updatedBy {
      email
      firstName
      lastName
    }
    appConfigs(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      sortBy: $sort
    ) {
      edges {
        node {
          ...AppConfigurationFragment
        }
      }

      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
    createdAt
    updatedAt
  }
`;
